import { Box, Card, Typography } from "@mui/material";

function StoreNotSelected() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#fdf6f0",
      }}
    >
      <Card sx={{ p: 4, maxWidth: 420, textAlign: "center" }}>
        <Typography variant="h5" fontWeight={700}>
          Store Not Selected
        </Typography>

        <Typography sx={{ mt: 2 }}>
          Please use a valid store link or scan the QR code provided by the store.
        </Typography>
      </Card>
    </Box>
  );
}

export default StoreNotSelected;
